import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { NoiseDataItem } from "../utils/types";

export type getNoiseDataResponse = {
  data: NoiseDataItem[];
  status: string;
  error_code: number;
  error_description: string;
};

export const getNoiseData = async (): Promise<
  AxiosResponse<getNoiseDataResponse>
> => {
  const config: AxiosRequestConfig = {
    method: "get",
    url: "https://api.paribesh.wtlprojects.com/api/v1/admin/get_noise_data_with_lat_long",
  };

  const response: AxiosResponse<getNoiseDataResponse> = await axios(config);

  return response;
};
